import BannersQuery from '../../query/Banners.query';
import { updateBanners } from './Banners.action';

import NoErrorQueryDispatcher from "Util/Request/NoErrorQueryDispatcher";

/**
 * Banners
 * @class BannersDispatcher
 * @extends QueryDispatcher
 */
export class BannersDispatcher extends NoErrorQueryDispatcher {

    __construct() {
        super.__construct('banners');
    }

    onSuccess(data, dispatch) {
        if (data?.banners) {
            dispatch(updateBanners(data.banners));
        }
    }

    onError(error, dispatch) {
        console.log(error);
        // dispatch(showNotification('error', 'Error fetching CMS Block!', error));
    }

    /**
     * Prepare Banners query
     * @param {{identifires: Array, fields: Array}} options An object containing different aspects of query, each item can be omitted
     * @return {Query} Banners query
     * @memberof BannersDispatcher
     */
    prepareRequest(options) {
        return BannersQuery.getQuery(options);
    }
}

export default new BannersDispatcher();
